import { FC, useEffect } from "react";
import styled from "styled-components";

import { ProductionSceneImageResource } from "@/types/resources";
import { Modal } from "@/components/Modal";
import { StyledDialog, CloseButton } from "@/components/AlertDialogs/Dialog";
import Text from "@/components/Text";
import ImagesModalCard from "./ImagesModalCard";
import { scrollBarStyles } from "@/utils/theme";

const Heading = styled(Text)`
  margin-bottom: 24px;
`;

const List = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
  max-height: 500px;
  overflow-y: auto;
  margin: 0 -10px;
  padding: 0 10px 24px;
  ${scrollBarStyles};
`;

const Dialog = styled(StyledDialog)`
  width: 696px;
  padding-bottom: 0;
`;

const Footer = styled.div`
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px -1px 8px rgba(34, 34, 34, 0.06);
  border-radius: 0px 0px 4px 4px;
  height: 24px;
  margin: 0 -24px;
`;

interface Props {
  onClose: () => void;
  images: ProductionSceneImageResource[];
}

const ImagesModal: FC<Props> = ({ onClose, images }) => {
  useEffect(() => {
    if (!images.length) {
      onClose();
    }
  }, [images, onClose]);

  return (
    <Modal zIndex={50}>
      <Dialog
        initial={{ scale: 0.3 }}
        animate={{ scale: 1 }}
        exit={{ scale: 0.3 }}
      >
        <CloseButton onClick={onClose} type="button">
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 1L1 13"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13 13L1 1"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </CloseButton>
        <Heading $type="heading2">Images & Descriptions</Heading>
        <List>
          {images.map((image) => (
            <ImagesModalCard key={image.id} image={image} />
          ))}
        </List>
        <Footer />
      </Dialog>
    </Modal>
  );
};

export default ImagesModal;
